<template>
    <section>
        <div class="text-subtitle-1 font-weight-bold mb-3">{{ titulo }}</div>
        <v-row>
        <v-col cols="12" sm="6" lg="3" v-for="(item,index) in totales" :key="index">
            <v-card variant="outlined" rounded="lg" class="pa-4 d-flex align-center" style="gap: 16px">
                <v-avatar :color="color" variant="tonal" size="48">
                    <v-icon :color="color">{{ icono }}</v-icon>
                </v-avatar>
                <div>
                    <div class="text-caption text-muted">{{ item.nombre }}</div>
                    <div class="text-h6 font-weight-bold">{{ item.total }}</div>
                </div>
            </v-card>
        </v-col>
        </v-row>
    </section>
</template>
<script>
export default {
    name: "CartasTotales",
    props: ["totales", "titulo", "icono", "color"]
}
</script>
